import axios from 'axios'

import IAdress from '../interfaces/adress'

export class HelperViaCep {
  static async getAdressByCep(cep: string): Promise<Partial<IAdress> | null> {
    const apiUrl = `https://viacep.com.br/ws/${cep}/json`

    try {
      const response = await axios.get(apiUrl)
      const {
        logradouro, complemento, bairro, localidade, uf,
      } = response.data
      return {
        zipcode: cep,
        street: logradouro,
        complement: complemento,
        neighborhood: bairro,
        city: localidade,
        state: uf,
      }
    } catch (error) {
      return {
        zipcode: '',
        street: '',
        complement: '',
        neighborhood: '',
        city: '',
        state: '',
      }
    }
  }
}
